import React from "react";
import { DIRECTORY_HERO, OPPORTUNITIES_HERO } from "@/lib/site-meta";

// Accent = --primary: 348 80% 50% → #E8184A  (artifacts/web/src/index.css:100)
const ACCENT = "#E8184A";

export default function OgTemplate() {
  // Optional ?scale=N (e.g. 2) renders the card scaled from the top-left
  // corner so a 2400x1260 viewport screenshot captures a crisp 2x asset.
  const params = new URLSearchParams(window.location.search);
  const scale = Math.max(1, Math.min(4, Number(params.get("scale")) || 1));

  // ?variant=directory (default) | invite
  const variant = params.get("variant") === "invite" ? "invite" : "directory";
  const hero = variant === "invite" ? OPPORTUNITIES_HERO : DIRECTORY_HERO;

  return (
    <div
      className={
        scale > 1
          ? "min-h-screen bg-zinc-900"
          : "min-h-screen bg-zinc-900 flex items-center justify-center"
      }
    >
      <div
        className="relative flex flex-col items-center justify-center bg-zinc-950 border-t-4 overflow-hidden"
        style={{
          width: 1200,
          height: 630,
          borderTopColor: ACCENT,
          flexShrink: 0,
          ...(scale > 1
            ? { transform: `scale(${scale})`, transformOrigin: "top left" }
            : {}),
        }}
      >
        {/* Subtle radial glow */}
        <div
          className="absolute pointer-events-none"
          style={{
            width: 900,
            height: 900,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(232,24,74,0.08) 0%, transparent 70%)",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />

        <div className="relative z-10 flex flex-col items-center gap-6 px-16 text-center">
          {/* Wordmark attribution */}
          <p
            className="text-zinc-500 uppercase"
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 14,
              letterSpacing: "0.2em",
            }}
          >
            THE CARRY NETWORK
          </p>

          {/* Hero headline */}
          <h1
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 80,
              fontWeight: 700,
              lineHeight: 1.05,
              letterSpacing: "-0.03em",
              textTransform: "uppercase",
              margin: 0,
              textAlign: "center",
            }}
          >
            <span style={{ color: "#ffffff", display: "block" }}>{hero.headlinePlain}</span>
            <span style={{ color: ACCENT, display: "block" }}>{hero.headlineAccent}</span>
          </h1>

          {/* Subhead */}
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 22,
              color: "#a1a1aa",
              maxWidth: 820,
              lineHeight: 1.55,
              margin: 0,
            }}
          >
            {hero.subhead}
          </p>

          {/* Footer disclaimer */}
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 13,
              color: "#52525b",
              marginTop: 8,
            }}
          >
            Not affiliated with or endorsed by Riot Games, Inc.
          </p>
        </div>
      </div>
    </div>
  );
}
